import React, { useEffect } from "react";
import { Menu, Grid, Popup } from "semantic-ui-react";
import IconSideBar from "./components/sideBar/IconSideBar";
import { IoIosBasket } from "react-icons/io";
import { FiUser } from "react-icons/fi";
import "./styles.css";
import { withStyles } from "@material-ui/core/styles";
import Badge from "@material-ui/core/Badge";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { getAllProducts } from "../../../../../redux/actions/products";
const MyMenu = (props) => {
  const {
    opened,
    nofications,
    setIndex,
    setOpened,
    getAllProducts,
    setVisibleSearch,
    auth,
    handleLogout,
  } = props;

  useEffect(() => {
    getAllProducts();
  }, [getAllProducts]);

  return (
    <>
      <Menu
        fluid
        inverted
        stackable
        id="menuMovil"
        className="d-flex flex-row justify-content-between rounded-0"
      >
        <div className="iconSideBar">
          <IconSideBar
            index={props.index}
            setIndex={setIndex}
            categories={props.categories}
            products={props.products}
            setVisibleSearch={setVisibleSearch}
          />
        </div>
        <div className="imagen">
          <img
            src="https://firebasestorage.googleapis.com/v0/b/floristeria-honduras-dev.appspot.com/o/Logo%2FLa%20Floristeri%CC%81a%20Honduras-41.png?alt=media&token=b100b358-5567-432b-b18d-fc1614df0f56"
            width="100%"
            alt="logo-floristeriaHonduras"
          />
        </div>

        <div className="shopping-NavBar" style={{ paddingRight: "40px" }}>
          <div className="Content-shopping-NavBar">
            <div className="user-icon-navbar-menu">
              <Popup
                trigger={<FiUser size={25} />}
                position="bottom right"
                hoverable
              >
                <Grid columns={1}>
                  {auth.isEmpty ? (
                    <>
                      <Grid.Column textAlign="center">
                        <Link to="/login" className="btn btn-outline-dark w-75">
                          <p className="font-weight-bolder">Ingresar</p>
                        </Link>
                      </Grid.Column>
                      <Grid.Column textAlign="center">
                        <Link to="/signup" className="btn btn-dark w-75">
                          <p className="font-weight-bolder">Registrarse</p>
                        </Link>
                      </Grid.Column>
                    </>
                  ) : (
                    <>
                      <Grid.Column textAlign="center">
                        <Link
                          to="/account"
                          className="btn btn-outline-dark w-75 "
                        >
                          <p className="font-weight-bolder">Cuenta</p>
                        </Link>
                      </Grid.Column>
                      <Grid.Column textAlign="center">
                        <Link
                          to="/"
                          className="btn btn-dark w-75 "
                          onClick={handleLogout}
                        >
                          <p className="font-weight-bolder">Salir</p>
                        </Link>
                      </Grid.Column>
                    </>
                  )}
                </Grid>
              </Popup>
            </div>
            <StyledBadge badgeContent={nofications} color="error" size={20}>
              <IoIosBasket
                size={20}
                color="black"
                className="FiShoppingCart"
                onClick={() => setOpened(!opened)}
              />
            </StyledBadge>
          </div>
        </div>
      </Menu>
    </>
  );
};

const StyledBadge = withStyles((theme) => ({
  badge: {
    zIndex: 1,
    right: 5,
    botton: 20,
    borderRadius: `50%`,
    border: "solid white 1.3px",
    padding: "1px 1px",
    margin: 1,
    color: "white",
  },
}))(Badge);

const mapStateToProps = (state) => {
  return {
    products: state.products.products,
  };
};

export default connect(mapStateToProps, {
  getAllProducts,
})(MyMenu);
